import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpIcon, MicIcon, SparklesIcon } from 'lucide-react';
import { quickPrompts } from '../../data/eau';
import { EauDialog } from './EauDialog';
const PANEL_LAYOUT_ID = 'atna-eau-panel';
interface EauAtnaProps {
  onConfigureAlerts: () => void;
  onPay: () => void;
}
export function EauAtna({
  onConfigureAlerts,
  onPay
}: EauAtnaProps) {
  const [value, setValue] = useState('');
  const [openedWith, setOpenedWith] = useState<string | null>(null);
  const open = (text: string) => {
    const trimmed = text.trim();
    if (!trimmed) return;
    setOpenedWith(trimmed);
    setValue('');
  };
  return <section aria-labelledby="atna-eau-titre" data-id="element-1190" data-mp="2mtliotii4gpy">
      <h2 id="atna-eau-titre" className="sr-only" data-id="element-1191" data-mp="2msae4rh8f4xs">
        Assistant ATNA — compteur d’eau
      </h2>

      {openedWith !== null ? <div className="h-[66px]" aria-hidden="true" data-id="element-1192" data-mp="16hq135iaxsmi" /> : <motion.div layoutId={PANEL_LAYOUT_ID} style={{
      borderRadius: 999
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-1193" data-mp="1bg1a5e0rvz3o">
          <form onSubmit={event => {
        event.preventDefault();
        open(value);
      }} className="flex items-center gap-3 rounded-full border border-slate-200 bg-white py-2.5 pl-5 pr-2.5 shadow-lg shadow-ville-navy/5 transition-colors duration-150 ease-ville focus-within:border-ville-indigo" data-id="element-1194" data-mp="3dbq1a88sdyqb">
            <SparklesIcon className="h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1195" data-mp="5154k5z6m6g1" />
            <label htmlFor="atna-eau-input" className="sr-only" data-id="element-1196" data-mp="2kakoaiwj01">
              Demander à ATNA
            </label>
            <input id="atna-eau-input" type="text" value={value} onChange={event => setValue(event.target.value)} placeholder="Demander à ATNA…" className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-ville-navy placeholder:text-slate-400 focus:outline-none sm:text-lg" data-id="element-1197" data-mp="9uhow3wtvr2z" />
            <button type="button" aria-label="Dicter votre question" className="grid h-10 w-10 shrink-0 place-items-center rounded-full text-slate-500 transition-colors duration-150 ease-ville hover:bg-ville-mist hover:text-ville-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue" data-id="element-1198" data-mp="qtr8nwb0m1x8">
              <MicIcon className="h-5 w-5" aria-hidden="true" data-id="element-1199" data-mp="19lk21rtzxp5h" />
            </button>
            <button type="submit" aria-label="Envoyer la question à ATNA" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-ville-navy text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-blue focus-visible:ring-offset-2" data-id="element-1200" data-mp="1ek55e04jooy5">
              <ArrowUpIcon className="h-5 w-5" aria-hidden="true" data-id="element-1201" data-mp="3q9xoxsocsdmt" />
            </button>
          </form>
        </motion.div>}

      <ul className="-mx-5 mt-4 flex snap-x gap-2.5 overflow-x-auto px-5 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0" data-id="element-1202" data-mp="27gw3v1p9378m">
        {quickPrompts.map(prompt => <li key={prompt} className="shrink-0 snap-start" data-id="element-1203" data-mp="1yocdspn0yaze">
            <button type="button" onClick={() => open(prompt)} className={prompt === 'Comment détecter les fuites' ? 'rounded-full border border-ville-navy bg-ville-navy px-4 py-2 text-sm font-semibold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2' : 'rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo'} data-id="element-1204" data-mp="1to6j10lgk8d3">
              {prompt}
            </button>
          </li>)}
      </ul>

      <AnimatePresence data-id="element-1205" data-mp="2tp1ldk33n2ry">
        {openedWith !== null && <EauDialog key="atna-eau-dialog" initialText={openedWith} layoutId={PANEL_LAYOUT_ID} onClose={() => setOpenedWith(null)} onConfigureAlerts={onConfigureAlerts} onPay={onPay} data-id="element-1206" data-mp="2fwlf8aewiomt" />}
      </AnimatePresence>
    </section>;
}